import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ProfileSelectors } from '../../../Redux/modules/profile/selectors';

import styles from './ProfileContainer.module.less';
import ProfileInformation from '../components/ProfileInformation';
import ChangePassword from '../components/ChangePassword';
import ChangeLanguage from '../components/ChangeLanguage';
import AccountActivation from '../components/AccountActivation';
import { ProfileActions } from '../../../Redux/modules/profile/actions';
import { OrganizationSelectors } from '../../../Redux/modules/organization/selectors';
import { AppSelectors } from '../../../Redux/modules/app/selectors';

const profileContainer = (props) => {
  const {
    profileDetails,
    changePassword,
    changeProfileDetails,
    profileDetailsUpdateStatus,
    passwordUpdateStatus,
    isLoadingPassword,
    isLoadingProfileUpdate,
    strongPasswordPolicy,
  } = props;
  // eslint-disable-next-line camelcase
  const name = profileDetails?.first_name ? `${profileDetails.first_name} ${profileDetails.last_name}` : '';
  useEffect(() => {
    props.onShowProfile();
    props.checkIsInvited();
  }, []);

  return (
    <div>
      <Helmet>
        <title id="page-title">{gettext('Profile')}</title>
      </Helmet>
      <div className={styles.section}>
        <div>
          <div>
            <div className={styles.container}>
              <ProfileInformation
                name={name}
                email={profileDetails.email}
                changeProfileDetails={changeProfileDetails}
                profileDetailsUpdateStatus={profileDetailsUpdateStatus}
                isLoading={isLoadingProfileUpdate}
              />
            </div>
            <div className={styles.sectionSeparator} />
            {props.isInvited ? (
              <div>
                <div className={styles.container}>
                  <AccountActivation />
                </div>
                <div className={styles.sectionSeparator} />
              </div>
            ) : null}
            <div className={styles.container}>
              <ChangePassword
                changePassword={changePassword}
                passwordUpdateStatus={passwordUpdateStatus}
                isLoading={isLoadingPassword}
                strongPasswordPolicy={strongPasswordPolicy}
                tracking={props.tracking}
                user={props.user}
              />
            </div>
            <div className={styles.sectionSeparator} />
            <div className={styles.container}>
              <ChangeLanguage />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profileDetails: ProfileSelectors.profileDetailsSelector(state),
    profileDetailsUpdateStatus: ProfileSelectors.profileDetailsUpdateStatusSelector(state),
    passwordUpdateStatus: ProfileSelectors.passwordUpdateStatusSelector(state),
    isLoadingPassword: ProfileSelectors.passwordLoadingSelector(state),
    isLoadingProfileUpdate: ProfileSelectors.profileLoadingSelector(state),
    isInvited: ProfileSelectors.profileIsInvitedSelector(state),
    strongPasswordPolicy: OrganizationSelectors.strongPasswordPolicySelector(state),
    tracking: AppSelectors.trackingSelector(state),
    user: AppSelectors.userSelector(state),
  };
};

const mapDispatchToProps = {
  onShowProfile: ProfileActions.profileDetailsFetch,
  changePassword: ProfileActions.changePassword,
  changeProfileDetails: ProfileActions.changeProfileDetails,
  checkIsInvited: ProfileActions.checkIsInvited,
};

profileContainer.propTypes = {
  profileDetails: PropTypes.object,
  changePassword: PropTypes.func,
  changeProfileDetails: PropTypes.func,
  onShowProfile: PropTypes.func,
  profileDetailsUpdateStatus: PropTypes.bool,
  passwordUpdateStatus: PropTypes.bool,
  isLoadingPassword: PropTypes.bool,
  isLoadingProfileUpdate: PropTypes.bool,
  isInvited: PropTypes.bool,
  checkIsInvited: PropTypes.func,
  strongPasswordPolicy: PropTypes.bool,
  tracking: PropTypes.object,
  user: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(profileContainer);
